import React from 'react';
import { SlideDown } from 'react-slidedown';

import 'react-slidedown/lib/slidedown.css';
import styles from '../../components/DropDown/DropDown.module.scss';

export type DropDownProps = {
  variant?: 'loggedin';
  isOpen?: boolean;
  shouldSlideDown?: boolean;
};

export const DropDown: React.FC<DropDownProps> = ({ children, isOpen, shouldSlideDown = false, variant }) => {
  return (
    <>
      {shouldSlideDown ? (
        <SlideDown className="dropdown-container">
          {isOpen ? (
            <div className={`${styles.dropdown} ${variant && styles[`dropdown--${variant}`]}`}>{children}</div>
          ) : null}
        </SlideDown>
      ) : (
        <>
          {isOpen ? (
            <div className={`${styles.dropdown} ${variant && styles[`dropdown--${variant}`]}`}>{children}</div>
          ) : null}
        </>
      )}
    </>
  );
};
